import React from 'react'
import LockerMenu from '../../Components/LockerMenu'
import { PageWrapper } from '../../Styles/style'
import Header from '../../Components/sections/header'
import About from '../../Components/sections/about'
import Marquee from '../../Components/sections/marquee'
import TokenDetail from '../../Components/sections/tokendetails'
import Faq from '../../Components/sections/faq'
import Footer from '../../Components/sections/footer'
import HowItWorks from '../../Components/sections/howitworks'
const MainPage = (props) => {
  return (
    <>
      <LockerMenu />
      <PageWrapper>
          <Header />
      </PageWrapper>
          <About />
          <HowItWorks />
          <Marquee />
          <TokenDetail />
          <Faq />
          <Footer />
    </>
  )
}

export default MainPage